import styled from 'styled-components';
import { SwitchProps } from '@sleepunique/types/switch-type';

export const SwitchButton = styled.button<SwitchProps>`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border: none;
  padding: var(--spacing-1);
  font-size: 1rem;
  font-weight: ${({ isActive }) => (isActive ? `bold;` : `300`)};
  background: none;
  color: ${({ dark }) => (dark ? `var(--color-sleepunique-teal)` : `var(--color-base-white)`)};
  border-right: 1px solid ${({ dark }) => (dark ? `var(--color-sleepunique-teal)` : `var(--color-base-white)`)};
  cursor: pointer;

  &:after {
    content: attr(data-text);
    content: attr(data-text) / '';
    height: 0;
    visibility: hidden;
    overflow: hidden;
    opacity: 0;
    user-select: none;
    pointer-events: none;
    font-weight: bold;
  }

  &:last-child {
    border: none;
  }
`;
